import {
  number, oneOfType, shape, string,
} from 'prop-types'

// Shape of one image as the modal shows it: a community gallery row (useGalleryImages) or a
// single image loaded by slug (toModalImage).
export const imageShape = {
  id: oneOfType([number, string]).isRequired,
  assetId: number,
  slug: string,
  title: string.isRequired,
  src: string.isRequired,
  aspectRatio: number.isRequired,
  prompt: string,
  createdAt: string,
  likeCount: number,
  user: shape({ username: string, avatar_url: string }),
}
